/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../components/ui-elements/table/StyledTableRow';
import { Grid, Tooltip } from "@mui/material";
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../../../../components/ui-elements/loader';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteOktaUser from './DeleteOktaUser';
import { getAllOktaUserList } from '../../../../../store/reducers/okta/oktaAction';

const OktaUsers = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const users = useSelector(state => state.okta.oktaUsers);

    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllOktaUserList()).unwrap();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    return (
        <>
            {!loading ? <>
                <Grid container justify="center">

                    <Grid xs={12} sm={12} md={12}>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell label="ID" />
                                        <StyledTableCell label="Name" />
                                        <StyledTableCell label="E-mail" />
                                        <StyledTableCell label="Login" />

                                        <StyledTableCell label="Status" />
                                        <StyledTableCell label="" />

                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {users?.length > 0 && users?.map((row) => (
                                        <React.Fragment key={row.id}>

                                            <StyledTableRow >
                                                <StyledTableCell label={row.id} />
                                                <StyledTableCell label={row.profile.firstName + " " + row.profile.lastName} />
                                                <StyledTableCell label={row.profile.email} />
                                                <StyledTableCell label={row.profile.login} />
                                                <StyledTableCell label={row.status} />

                                                 <StyledTableCell>
                                                    <Tooltip title="Delete User">
                                                        <span>
                                                            <DeleteOktaUser id={row.id}  lastName={row.profile.lastName}  firstName={row.profile.firstName} />
                                                        </span>
                                                    </Tooltip>

                                                </StyledTableCell>

                                            </StyledTableRow>
                                        </React.Fragment>

                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </> : (<Loader />)}

        </>
    )

}

export default OktaUsers;
